/**
 * Do not edit directly
 * Generated on Fri, 21 May 2021 21:11:43 GMT
 */

import Enum from '@rover/shared/js/types/Enum';

type ContrastRating = 'AAA' | 'AA' | '•AA';

type ColorType = {
  name: string;
  rgba: { r: number; g: number; b: number; a: number };
  hex: string;
  blackTextContrastRating?: ContrastRating;
  whiteTextContrastRating?: ContrastRating;
};

class Color extends Enum<ColorType> {
  static NEUTRAL_12 = new Color({
    name: 'NEUTRAL_12',
    rgba: { r: 27, g: 31, b: 35, a: 1 },
    hex: '#1B1F23',
    whiteTextContrastRating: 'AAA',
  });

  static NEUTRAL_28 = new Color({
    name: 'NEUTRAL_28',
    rgba: { r: 64, g: 72, b: 79, a: 1 },
    hex: '#40484F',
    whiteTextContrastRating: 'AAA',
  });

  static NEUTRAL_44 = new Color({
    name: 'NEUTRAL_44',
    rgba: { r: 102, g: 114, b: 124, a: 1 },
    hex: '#66727C',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static NEUTRAL_56 = new Color({
    name: 'NEUTRAL_56',
    rgba: { r: 132, g: 144, b: 154, a: 1 },
    hex: '#84909A',
    blackTextContrastRating: 'AA',
    whiteTextContrastRating: '•AA',
  });

  static NEUTRAL_84 = new Color({
    name: 'NEUTRAL_84',
    rgba: { r: 207, g: 215, b: 222, a: 1 },
    hex: '#CFD7DE',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_88 = new Color({
    name: 'NEUTRAL_88',
    rgba: { r: 220, g: 225, b: 229, a: 1 },
    hex: '#DCE1E5',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_92 = new Color({
    name: 'NEUTRAL_92',
    rgba: { r: 232, g: 235, b: 237, a: 1 },
    hex: '#E8EBED',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_96 = new Color({
    name: 'NEUTRAL_96',
    rgba: { r: 244, g: 245, b: 246, a: 1 },
    hex: '#F4F5F6',
    blackTextContrastRating: 'AAA',
  });

  static NEUTRAL_100 = new Color({
    name: 'NEUTRAL_100',
    rgba: { r: 255, g: 255, b: 255, a: 1 },
    hex: '#FFFFFF',
    blackTextContrastRating: 'AAA',
  });

  static GREEN_24 = new Color({
    name: 'GREEN_24',
    rgba: { r: 0, g: 121, b: 72, a: 1 },
    hex: '#007948',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static GREEN_28 = new Color({
    name: 'GREEN_28',
    rgba: { r: 9, g: 136, b: 85, a: 1 },
    hex: '#098855',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: '•AA',
  });

  static GREEN_70 = new Color({
    name: 'GREEN_70',
    rgba: { r: 113, g: 244, b: 191, a: 1 },
    hex: '#71F4BF',
    blackTextContrastRating: 'AAA',
  });

  static GREEN_96 = new Color({
    name: 'GREEN_96',
    rgba: { r: 236, g: 254, b: 247, a: 1 },
    hex: '#ECFEF7',
    blackTextContrastRating: 'AAA',
  });

  static GREEN_BASE = new Color({
    name: 'GREEN_BASE',
    rgba: { r: 20, g: 169, b: 109, a: 1 },
    hex: '#14A96D',
    blackTextContrastRating: 'AA',
  });

  static BLUE_28 = new Color({
    name: 'BLUE_28',
    rgba: { r: 6, g: 116, b: 138, a: 1 },
    hex: '#06748A',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static BLUE_32 = new Color({
    name: 'BLUE_32',
    rgba: { r: 2, g: 129, b: 162, a: 1 },
    hex: '#0281A2',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static BLUE_70 = new Color({
    name: 'BLUE_70',
    rgba: { r: 125, g: 211, b: 232, a: 1 },
    hex: '#7DD3E8',
    blackTextContrastRating: 'AAA',
  });

  static BLUE_96 = new Color({
    name: 'BLUE_96',
    rgba: { r: 236, g: 251, b: 254, a: 1 },
    hex: '#ECFBFE',
    blackTextContrastRating: 'AAA',
  });

  static BLUE_BASE = new Color({
    name: 'BLUE_BASE',
    rgba: { r: 22, g: 162, b: 187, a: 1 },
    hex: '#16A2BB',
    blackTextContrastRating: 'AA',
    whiteTextContrastRating: '•AA',
  });

  static PURPLE_40 = new Color({
    name: 'PURPLE_40',
    rgba: { r: 80, g: 75, b: 180, a: 1 },
    hex: '#504BB4',
    whiteTextContrastRating: 'AA',
  });

  static PURPLE_70 = new Color({
    name: 'PURPLE_70',
    rgba: { r: 138, g: 133, b: 224, a: 1 },
    hex: '#8A85E0',
    blackTextContrastRating: 'AA',
  });

  static PURPLE_96 = new Color({
    name: 'PURPLE_96',
    rgba: { r: 236, g: 236, b: 254, a: 1 },
    hex: '#ECECFE',
    blackTextContrastRating: 'AAA',
  });

  static PURPLE_BASE = new Color({
    name: 'PURPLE_BASE',
    rgba: { r: 105, g: 100, b: 189, a: 1 },
    hex: '#6964BD',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static RED_40 = new Color({
    name: 'RED_40',
    rgba: { r: 194, g: 10, b: 47, a: 1 },
    hex: '#C20A2F',
    whiteTextContrastRating: 'AA',
  });

  static RED_70 = new Color({
    name: 'RED_70',
    rgba: { r: 252, g: 105, b: 123, a: 1 },
    hex: '#FC697B',
    blackTextContrastRating: 'AA',
  });

  static RED_96 = new Color({
    name: 'RED_96',
    rgba: { r: 254, g: 236, b: 238, a: 1 },
    hex: '#FEECEE',
    blackTextContrastRating: 'AAA',
  });

  static RED_BASE = new Color({
    name: 'RED_BASE',
    rgba: { r: 229, g: 26, b: 66, a: 1 },
    hex: '#E51A42',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static ORANGE_40 = new Color({
    name: 'ORANGE_40',
    rgba: { r: 204, g: 78, b: 0, a: 1 },
    hex: '#CC4E00',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static ORANGE_70 = new Color({
    name: 'ORANGE_70',
    rgba: { r: 255, g: 161, b: 102, a: 1 },
    hex: '#FFA166',
    blackTextContrastRating: 'AAA',
  });

  static ORANGE_96 = new Color({
    name: 'ORANGE_96',
    rgba: { r: 254, g: 243, b: 236, a: 1 },
    hex: '#FEF3EC',
    blackTextContrastRating: 'AAA',
  });

  static ORANGE_BASE = new Color({
    name: 'ORANGE_BASE',
    rgba: { r: 255, g: 129, b: 51, a: 1 },
    hex: '#FF8133',
    blackTextContrastRating: 'AA',
  });

  static YELLOW_28 = new Color({
    name: 'YELLOW_28',
    rgba: { r: 140, g: 108, b: 5, a: 1 },
    hex: '#8C6C05',
    blackTextContrastRating: '•AA',
    whiteTextContrastRating: 'AA',
  });

  static YELLOW_70 = new Color({
    name: 'YELLOW_70',
    rgba: { r: 247, g: 217, b: 110, a: 1 },
    hex: '#F7D96E',
    blackTextContrastRating: 'AAA',
  });

  static YELLOW_96 = new Color({
    name: 'YELLOW_96',
    rgba: { r: 254, g: 250, b: 236, a: 1 },
    hex: '#FEFAEC',
    blackTextContrastRating: 'AAA',
  });

  static YELLOW_BASE = new Color({
    name: 'YELLOW_BASE',
    rgba: { r: 255, g: 207, b: 51, a: 1 },
    hex: '#FFCF33',
    blackTextContrastRating: 'AAA',
  });

  static BRAND_ROVER = new Color({
    name: 'BRAND_ROVER',
    rgba: { r: 0, g: 189, b: 112, a: 1 },
    hex: '#00BD70',
    blackTextContrastRating: 'AA',
  });

  static BRAND_DOGBUDDY = new Color({
    name: 'BRAND_DOGBUDDY',
    rgba: { r: 255, g: 90, b: 91, a: 1 },
    hex: '#FF5A5B',
    blackTextContrastRating: 'AA',
    whiteTextContrastRating: '•AA',
  });

  static BRAND_FACEBOOK = new Color({
    name: 'BRAND_FACEBOOK',
    rgba: { r: 59, g: 89, b: 152, a: 1 },
    hex: '#3B5998',
    whiteTextContrastRating: 'AA',
  });

  static BRAND_INSTAGRAM = new Color({
    name: 'BRAND_INSTAGRAM',
    rgba: { r: 138, g: 58, b: 185, a: 1 },
    hex: '#8A3AB9',
    whiteTextContrastRating: 'AA',
  });

  static BRAND_TWITTER = new Color({
    name: 'BRAND_TWITTER',
    rgba: { r: 29, g: 161, b: 242, a: 1 },
    hex: '#1DA1F2',
    blackTextContrastRating: 'AA',
  });

  static BRAND_PINTEREST = new Color({
    name: 'BRAND_PINTEREST',
    rgba: { r: 200, g: 35, b: 44, a: 1 },
    hex: '#C8232C',
    whiteTextContrastRating: 'AA',
  });

  static BRAND_GOOGLE = new Color({
    name: 'BRAND_GOOGLE',
    rgba: { r: 66, g: 133, b: 244, a: 1 },
    hex: '#4285F4',
    blackTextContrastRating: 'AA',
    whiteTextContrastRating: '•AA',
  });

  static TEMPORARY_NEUTRAL_100 = new Color({
    name: 'TEMPORARY_NEUTRAL_100',
    rgba: { r: 244, g: 245, b: 246, a: 1 },
    hex: '#F4F5F6',
  });

  static TEMPORARY_NEUTRAL_200 = new Color({
    name: 'TEMPORARY_NEUTRAL_200',
    rgba: { r: 230, g: 232, b: 235, a: 1 },
    hex: '#E6E8EB',
  });

  static TEMPORARY_NEUTRAL_300 = new Color({
    name: 'TEMPORARY_NEUTRAL_300',
    rgba: { r: 215, g: 220, b: 224, a: 1 },
    hex: '#D7DCE0',
  });

  static TEMPORARY_NEUTRAL_400 = new Color({
    name: 'TEMPORARY_NEUTRAL_400',
    rgba: { r: 201, g: 207, b: 212, a: 1 },
    hex: '#C9CFD4',
  });

  static TEMPORARY_NEUTRAL_500 = new Color({
    name: 'TEMPORARY_NEUTRAL_500',
    rgba: { r: 158, g: 165, b: 172, a: 1 },
    hex: '#9EA5AC',
  });

  static TEMPORARY_NEUTRAL_600 = new Color({
    name: 'TEMPORARY_NEUTRAL_600',
    rgba: { r: 118, g: 124, b: 130, a: 1 },
    hex: '#767C82',
  });

  static TEMPORARY_NEUTRAL_700 = new Color({
    name: 'TEMPORARY_NEUTRAL_700',
    rgba: { r: 98, g: 104, b: 110, a: 1 },
    hex: '#62686E',
  });

  static TEMPORARY_NEUTRAL_800 = new Color({
    name: 'TEMPORARY_NEUTRAL_800',
    rgba: { r: 64, g: 67, b: 71, a: 1 },
    hex: '#404347',
  });

  static TEMPORARY_NEUTRAL_900 = new Color({
    name: 'TEMPORARY_NEUTRAL_900',
    rgba: { r: 31, g: 33, b: 36, a: 1 },
    hex: '#1F2124',
  });

  static TEMPORARY_BLUE_100 = new Color({
    name: 'TEMPORARY_BLUE_100',
    rgba: { r: 235, g: 239, b: 255, a: 1 },
    hex: '#EBEFFF',
  });

  static TEMPORARY_BLUE_200 = new Color({
    name: 'TEMPORARY_BLUE_200',
    rgba: { r: 189, g: 202, b: 255, a: 1 },
    hex: '#BDCAFF',
  });

  static TEMPORARY_BLUE_300 = new Color({
    name: 'TEMPORARY_BLUE_300',
    rgba: { r: 145, g: 175, b: 252, a: 1 },
    hex: '#91AFFC',
  });

  static TEMPORARY_BLUE_400 = new Color({
    name: 'TEMPORARY_BLUE_400',
    rgba: { r: 99, g: 138, b: 235, a: 1 },
    hex: '#638AEB',
  });

  static TEMPORARY_BLUE_500 = new Color({
    name: 'TEMPORARY_BLUE_500',
    rgba: { r: 64, g: 112, b: 229, a: 1 },
    hex: '#4070E5',
  });

  static TEMPORARY_BLUE_600 = new Color({
    name: 'TEMPORARY_BLUE_600',
    rgba: { r: 49, g: 81, b: 212, a: 1 },
    hex: '#3151D4',
  });

  static TEMPORARY_BLUE_700 = new Color({
    name: 'TEMPORARY_BLUE_700',
    rgba: { r: 40, g: 65, b: 166, a: 1 },
    hex: '#2841A6',
  });

  static TEMPORARY_BLUE_800 = new Color({
    name: 'TEMPORARY_BLUE_800',
    rgba: { r: 32, g: 49, b: 115, a: 1 },
    hex: '#203173',
  });

  static TEMPORARY_BLUE_900 = new Color({
    name: 'TEMPORARY_BLUE_900',
    rgba: { r: 29, g: 34, b: 71, a: 1 },
    hex: '#1D2247',
  });

  static TEMPORARY_CYAN_100 = new Color({
    name: 'TEMPORARY_CYAN_100',
    rgba: { r: 230, g: 248, b: 252, a: 1 },
    hex: '#E6F8FC',
  });

  static TEMPORARY_CYAN_200 = new Color({
    name: 'TEMPORARY_CYAN_200',
    rgba: { r: 182, g: 240, b: 249, a: 1 },
    hex: '#B6F0F9',
  });

  static TEMPORARY_CYAN_300 = new Color({
    name: 'TEMPORARY_CYAN_300',
    rgba: { r: 120, g: 228, b: 245, a: 1 },
    hex: '#78E4F5',
  });

  static TEMPORARY_CYAN_400 = new Color({
    name: 'TEMPORARY_CYAN_400',
    rgba: { r: 67, g: 208, b: 229, a: 1 },
    hex: '#43D0E5',
  });

  static TEMPORARY_CYAN_500 = new Color({
    name: 'TEMPORARY_CYAN_500',
    rgba: { r: 32, g: 199, b: 225, a: 1 },
    hex: '#20C7E1',
  });

  static TEMPORARY_CYAN_600 = new Color({
    name: 'TEMPORARY_CYAN_600',
    rgba: { r: 23, g: 163, b: 181, a: 1 },
    hex: '#17A3B5',
  });

  static TEMPORARY_CYAN_700 = new Color({
    name: 'TEMPORARY_CYAN_700',
    rgba: { r: 21, g: 122, b: 135, a: 1 },
    hex: '#157A87',
  });

  static TEMPORARY_CYAN_800 = new Color({
    name: 'TEMPORARY_CYAN_800',
    rgba: { r: 20, g: 85, b: 94, a: 1 },
    hex: '#14555E',
  });

  static TEMPORARY_CYAN_900 = new Color({
    name: 'TEMPORARY_CYAN_900',
    rgba: { r: 15, g: 47, b: 51, a: 1 },
    hex: '#0F2F33',
  });

  static TEMPORARY_GREEN_100 = new Color({
    name: 'TEMPORARY_GREEN_100',
    rgba: { r: 235, g: 255, b: 246, a: 1 },
    hex: '#EBFFF6',
  });

  static TEMPORARY_GREEN_200 = new Color({
    name: 'TEMPORARY_GREEN_200',
    rgba: { r: 194, g: 245, b: 221, a: 1 },
    hex: '#C2F5DD',
  });

  static TEMPORARY_GREEN_300 = new Color({
    name: 'TEMPORARY_GREEN_300',
    rgba: { r: 97, g: 232, b: 167, a: 1 },
    hex: '#61E8A7',
  });

  static TEMPORARY_GREEN_400 = new Color({
    name: 'TEMPORARY_GREEN_400',
    rgba: { r: 38, g: 201, b: 122, a: 1 },
    hex: '#26C97A',
  });

  static TEMPORARY_GREEN_500 = new Color({
    name: 'TEMPORARY_GREEN_500',
    rgba: { r: 0, g: 191, b: 99, a: 1 },
    hex: '#00BF63',
  });

  static TEMPORARY_GREEN_600 = new Color({
    name: 'TEMPORARY_GREEN_600',
    rgba: { r: 4, g: 152, b: 90, a: 1 },
    hex: '#04985A',
  });

  static TEMPORARY_GREEN_700 = new Color({
    name: 'TEMPORARY_GREEN_700',
    rgba: { r: 0, g: 121, b: 64, a: 1 },
    hex: '#007940',
  });

  static TEMPORARY_GREEN_800 = new Color({
    name: 'TEMPORARY_GREEN_800',
    rgba: { r: 1, g: 86, b: 53, a: 1 },
    hex: '#015635',
  });

  static TEMPORARY_GREEN_900 = new Color({
    name: 'TEMPORARY_GREEN_900',
    rgba: { r: 5, g: 51, b: 33, a: 1 },
    hex: '#053321',
  });

  static TEMPORARY_ORANGE_100 = new Color({
    name: 'TEMPORARY_ORANGE_100',
    rgba: { r: 252, g: 245, b: 239, a: 1 },
    hex: '#FCF5EF',
  });

  static TEMPORARY_ORANGE_200 = new Color({
    name: 'TEMPORARY_ORANGE_200',
    rgba: { r: 255, g: 212, b: 168, a: 1 },
    hex: '#FFD4A8',
  });

  static TEMPORARY_ORANGE_300 = new Color({
    name: 'TEMPORARY_ORANGE_300',
    rgba: { r: 255, g: 169, b: 110, a: 1 },
    hex: '#FFA96E',
  });

  static TEMPORARY_ORANGE_400 = new Color({
    name: 'TEMPORARY_ORANGE_400',
    rgba: { r: 255, g: 138, b: 70, a: 1 },
    hex: '#FF8A46',
  });

  static TEMPORARY_ORANGE_500 = new Color({
    name: 'TEMPORARY_ORANGE_500',
    rgba: { r: 255, g: 117, b: 37, a: 1 },
    hex: '#FF7525',
  });

  static TEMPORARY_ORANGE_600 = new Color({
    name: 'TEMPORARY_ORANGE_600',
    rgba: { r: 224, g: 98, b: 27, a: 1 },
    hex: '#E0621B',
  });

  static TEMPORARY_ORANGE_700 = new Color({
    name: 'TEMPORARY_ORANGE_700',
    rgba: { r: 187, g: 79, b: 18, a: 1 },
    hex: '#BB4F12',
  });

  static TEMPORARY_ORANGE_800 = new Color({
    name: 'TEMPORARY_ORANGE_800',
    rgba: { r: 119, g: 50, b: 11, a: 1 },
    hex: '#77320B',
  });

  static TEMPORARY_ORANGE_900 = new Color({
    name: 'TEMPORARY_ORANGE_900',
    rgba: { r: 51, g: 23, b: 6, a: 1 },
    hex: '#331706',
  });

  static TEMPORARY_PINK_100 = new Color({
    name: 'TEMPORARY_PINK_100',
    rgba: { r: 255, g: 242, b: 247, a: 1 },
    hex: '#FFF2F7',
  });

  static TEMPORARY_PINK_200 = new Color({
    name: 'TEMPORARY_PINK_200',
    rgba: { r: 255, g: 214, b: 232, a: 1 },
    hex: '#FFD6E8',
  });

  static TEMPORARY_PINK_300 = new Color({
    name: 'TEMPORARY_PINK_300',
    rgba: { r: 255, g: 166, b: 204, a: 1 },
    hex: '#FFA6CC',
  });

  static TEMPORARY_PINK_400 = new Color({
    name: 'TEMPORARY_PINK_400',
    rgba: { r: 255, g: 125, b: 177, a: 1 },
    hex: '#FF7DB1',
  });

  static TEMPORARY_PINK_500 = new Color({
    name: 'TEMPORARY_PINK_500',
    rgba: { r: 255, g: 102, b: 163, a: 1 },
    hex: '#FF66A3',
  });

  static TEMPORARY_PINK_600 = new Color({
    name: 'TEMPORARY_PINK_600',
    rgba: { r: 209, g: 56, b: 128, a: 1 },
    hex: '#D13880',
  });

  static TEMPORARY_PINK_700 = new Color({
    name: 'TEMPORARY_PINK_700',
    rgba: { r: 153, g: 33, b: 95, a: 1 },
    hex: '#99215F',
  });

  static TEMPORARY_PINK_800 = new Color({
    name: 'TEMPORARY_PINK_800',
    rgba: { r: 51, g: 10, b: 34, a: 1 },
    hex: '#330A22',
  });

  static TEMPORARY_PINK_900 = new Color({
    name: 'TEMPORARY_PINK_900',
    rgba: { r: 51, g: 23, b: 6, a: 1 },
    hex: '#331706',
  });

  static TEMPORARY_ROSE_100 = new Color({
    name: 'TEMPORARY_ROSE_100',
    rgba: { r: 252, g: 239, b: 239, a: 1 },
    hex: '#FCEFEF',
  });

  static TEMPORARY_ROSE_200 = new Color({
    name: 'TEMPORARY_ROSE_200',
    rgba: { r: 255, g: 201, b: 202, a: 1 },
    hex: '#FFC9CA',
  });

  static TEMPORARY_ROSE_300 = new Color({
    name: 'TEMPORARY_ROSE_300',
    rgba: { r: 255, g: 145, b: 149, a: 1 },
    hex: '#FF9195',
  });

  static TEMPORARY_ROSE_400 = new Color({
    name: 'TEMPORARY_ROSE_400',
    rgba: { r: 255, g: 114, b: 126, a: 1 },
    hex: '#FF727E',
  });

  static TEMPORARY_ROSE_500 = new Color({
    name: 'TEMPORARY_ROSE_500',
    rgba: { r: 255, g: 89, b: 97, a: 1 },
    hex: '#FF5961',
  });

  static TEMPORARY_ROSE_600 = new Color({
    name: 'TEMPORARY_ROSE_600',
    rgba: { r: 194, g: 47, b: 59, a: 1 },
    hex: '#C22F3B',
  });

  static TEMPORARY_ROSE_700 = new Color({
    name: 'TEMPORARY_ROSE_700',
    rgba: { r: 153, g: 42, b: 49, a: 1 },
    hex: '#992A31',
  });

  static TEMPORARY_ROSE_800 = new Color({
    name: 'TEMPORARY_ROSE_800',
    rgba: { r: 102, g: 29, b: 34, a: 1 },
    hex: '#661D22',
  });

  static TEMPORARY_ROSE_900 = new Color({
    name: 'TEMPORARY_ROSE_900',
    rgba: { r: 51, g: 16, b: 19, a: 1 },
    hex: '#331013',
  });

  static TEMPORARY_YELLOW_100 = new Color({
    name: 'TEMPORARY_YELLOW_100',
    rgba: { r: 252, g: 246, b: 235, a: 1 },
    hex: '#FCF6EB',
  });

  static TEMPORARY_YELLOW_200 = new Color({
    name: 'TEMPORARY_YELLOW_200',
    rgba: { r: 255, g: 236, b: 189, a: 1 },
    hex: '#FFECBD',
  });

  static TEMPORARY_YELLOW_300 = new Color({
    name: 'TEMPORARY_YELLOW_300',
    rgba: { r: 255, g: 215, b: 106, a: 1 },
    hex: '#FFD76A',
  });

  static TEMPORARY_YELLOW_400 = new Color({
    name: 'TEMPORARY_YELLOW_400',
    rgba: { r: 255, g: 190, b: 61, a: 1 },
    hex: '#FFBE3D',
  });

  static TEMPORARY_YELLOW_500 = new Color({
    name: 'TEMPORARY_YELLOW_500',
    rgba: { r: 255, g: 171, b: 28, a: 1 },
    hex: '#FFAB1C',
  });

  static TEMPORARY_YELLOW_600 = new Color({
    name: 'TEMPORARY_YELLOW_600',
    rgba: { r: 207, g: 145, b: 31, a: 1 },
    hex: '#CF911F',
  });

  static TEMPORARY_YELLOW_700 = new Color({
    name: 'TEMPORARY_YELLOW_700',
    rgba: { r: 153, g: 105, b: 29, a: 1 },
    hex: '#99691D',
  });

  static TEMPORARY_YELLOW_800 = new Color({
    name: 'TEMPORARY_YELLOW_800',
    rgba: { r: 102, g: 73, b: 27, a: 1 },
    hex: '#66491B',
  });

  static TEMPORARY_YELLOW_900 = new Color({
    name: 'TEMPORARY_YELLOW_900',
    rgba: { r: 51, g: 38, b: 18, a: 1 },
    hex: '#332612',
  });

  static TEMPORARY_WHITE = new Color({
    name: 'TEMPORARY_WHITE',
    rgba: { r: 255, g: 255, b: 255, a: 1 },
    hex: '#FFFFFF',
  });

  static TEMPORARY_BLACK = new Color({
    name: 'TEMPORARY_BLACK',
    rgba: { r: 0, g: 0, b: 0, a: 1 },
    hex: '#000000',
  });

  static isLocked = true;

  toString(): string {
    const { r, g, b, a } = this.value.rgba;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  toTestString(): string {
    return this.toString().replace(/\s/g, '');
  }

  toHexString(): string {
    return this.value.hex;
  }

  withOpacity(opacity: number): string {
    const { r, g, b } = this.value.rgba;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
}
export default Color;



// WEBPACK FOOTER //
// ../kibble/tokens/build/es6/Color.ts